export const buildPaginationNav = (list) => {
  let { currentPage, totalPages, container } = list,
    pg = "";
  if (totalPages !== 0) {
    pg = `${currentPage} of ${totalPages}`;
  }
  let paginationContainer = document.getElementById(`${container}`);
  let nav = `<nav aria-label="Page navigation pagination my-2">
    <div class="col-md-12 text-center" id="${container}-pageNums">${pg}</div>
    <ul class="pagination justify-content-center">
      <li class="page-item pagination-button">
          <a class="page-link" href="#" id="firstPage">First</a>
      </li>
      <li class="page-item pagination-button">
          <a class="page-link" id="nextPage" href="#">Next</a>
      </li>
      <li class="page-item pagination-button">
          <a class="page-link" href="#" id="previousPage">Previous</a>
      </li>
      <li class="page-item pagination-button">
          <a class="page-link" id="lastPage" href="#">Last</a>
      </li>
    </ul>
  </nav>`;
  paginationContainer.innerHTML = "";
  paginationContainer.innerHTML = nav;
};
